import { ValueElement } from "./Base";
import { TextInputElement, TextInputType } from "./TextInput";

export default class CheckboxElement extends ValueElement {
  private instance: HTMLSpanElement;

  private checkbox: HTMLInputElement;

  private onChangeClick = () => this.onChange();

  constructor(name: string,
              value: boolean = false,
              classes: string[] = []) {
    super(name);
    this.instance = document.createElement("span");

    this.checkbox = new TextInputElement(name,
                                         value.toString(),
                                         TextInputType.Checkbox).element as HTMLInputElement;
    this.instance.appendChild(this.checkbox);
    const uiCheckbox = document.createElement("span");
    uiCheckbox.classList.add(...classes);
    this.instance.appendChild(uiCheckbox);
    this.checkbox.addEventListener("change", this.onChangeClick);
  }

  get element(): HTMLElement {
    return this.instance;
  }

  get value(): any {
    return !!this.checkbox.checked;
  }

  set value(val: any) {
    // Profile APIs may deliver granted flags as boolean, 0/1 or strings —
    // normalise, and only click when the state actually changes so the
    // change event still fires without ever toggling the wrong way.
    const next = val === true || val === 1 || val === "true" || val === "1";
    if (this.checkbox.checked !== next) {
      this.checkbox.click();
    }
  }

  dispose(): void {
    this.checkbox.removeEventListener("change", this.onChangeClick);
  }

  disable(): void {
    this.checkbox.disabled = true;
  }
}
